// 用户资料填写状态：1、用户资料未填写 2、用户资料填写中 3、用户资料填写完成
export enum UserInfoStatus {
  Init = 1,
  Filling = 2,
  Completed = 3,
}
